import { type OpeningSideName, FRONT, BACK } from "building-types/openings/openingTypes";

export function sideOpposite(side: OpeningSideName): OpeningSideName {
  return side === FRONT ? BACK : FRONT;
}
